module.exports = __webpack_public_path__ + "static/media/Shells_All_Devices_Education.686e6cd7.png";